import * as xAPIModels from '../models/xAPIModels';
import * as appHelper from './appHelper';
import * as dataHelper from './dataHelper';
import * as kpiHelper from './kpiHelper';
import * as localStorage from '../localStorage/localStorage';
import * as objectConstants from '../constants/objectConstants';
import _ from 'lodash';
import striptags from 'striptags';


export function setMultiAnswerChoiceInteractionData(obj,responseObj){
    let objLocale = appHelper.getLocalData(obj);
    //SET RESULT
    let resultParam = Object.assign({}, xAPIModels.RESULT,{
        completion:  responseObj.outcome.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN,
        success: obj.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE || responseObj.outcome.result === objectConstants.RESULT_BEST,
        response: setQuestionResponses(responseObj.checkedOptions),
        //score: obj.scoring_type === objectConstants.SCORING_TYPE_ASSESSED && responseObj.outcome.kpis !== null  ? setScore(obj, responseObj) : getScoreObj(obj.scoring_type, responseObj.outcome.result)
        score: getScoreObj(obj.scoring_type, responseObj.outcome.result)
    });

    if(obj.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE){
        resultParam = Object.assign({}, _.omit(resultParam, 'success'));
    }

    //SET OBJECT
    let correctAnswers = appHelper.getTypeCount(obj.options, "result", "best");

    let definition = {
        name:{
            "en-US": striptags(objLocale.description)
        },
        description:{
            "en-US": striptags(objLocale.description)
        },
        type: 'http://adlnet.gov/expapi/activities/cmi.interaction',
            interactionType : "choice",
            //correctResponsesPattern: [setQuestionResponses(correctAnswers)],
            //correctResponsesPattern: obj.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE ? []: [setQuestionResponses(correctAnswers)],
            choices: setChoices(obj.options)
    };

    if(obj.scoring_type !== objectConstants.SCORING_TYPE_REFLECTIVE){
        definition['correctResponsesPattern'] = [setQuestionResponses(correctAnswers)];
    }

    let objectParam =  Object.assign({}, xAPIModels.CHOICE_OBJECT, {
        id: setId(obj,responseObj),
        definition: definition,
    });



    return Object.assign({},xAPIModels.CHOICE,{
        result: resultParam,
        object: objectParam
    });

}

export function setSingleAnwserChoiceInteractionData(obj,responseObj){
    let objLocale = appHelper.getLocalData(obj);
    //SET RESULT
    let optionLocale = appHelper.getLocalData(responseObj.latestResponse);
    //striptags(optionLocale.option)

    let resultParam = Object.assign({}, xAPIModels.RESULT,{
        completion:  responseObj.latestResponse.progression !== objectConstants.OBJECT_PROGRESSION_TRY_AGAIN,
        success: obj.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE || responseObj.latestResponse.result === objectConstants.RESULT_BEST,
        //response: responseObj.latestResponse.option_id.toString(),
        response: striptags(optionLocale.option),
        //score: obj.scoring_type === objectConstants.SCORING_TYPE_ASSESSED && responseObj.latestResponse.kpis !== null ? setScore(obj, responseObj) : getScoreObj(obj.scoring_type, responseObj.outcome.result)
        score: getScoreObj(obj.scoring_type,responseObj.latestResponse.result)
    });

    if(obj.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE){
        resultParam = Object.assign({}, _.omit(resultParam, 'success'));
    }

    //SET OBJECT
    let correctAnswers = appHelper.getTypeCount(obj.options, "result", "best");

    let definition = {
        name:{
            "en-US": striptags(objLocale.description)
        },
        description:{
            "en-US": striptags(objLocale.description)
        },
        type: 'http://adlnet.gov/expapi/activities/cmi.interaction',
        interactionType : "choice",
        choices: setChoices(obj.options)
    };

    if(obj.scoring_type !== objectConstants.SCORING_TYPE_REFLECTIVE){
        definition['correctResponsesPattern'] = [setQuestionResponses(correctAnswers)];
    }

    let objectParam =  Object.assign({}, xAPIModels.CHOICE_OBJECT, {

        id: setId(obj,responseObj),
        definition: definition,

    });

    return Object.assign({},xAPIModels.CHOICE,{
        result: resultParam,
        object: objectParam
    });



}


export function getMultipleChoiceIds(params) {

    let activityId = "";


    if (appHelper.isDefined(params.parent_screen_id)) {
        activityId = `bite_id:${params.bite_id}/screen_id:${params.parent_screen_id}/sub_screen_id:${params.screen_id}/asset_id:${params.asset_id}`;
    } else {
        activityId = `bite_id:${params.bite_id}/screen_id:${params.screen_id}/asset_id:${params.asset_id}`;
    }

    return {
        id: params.asset_id,
        activityId: activityId,
    };

}

    export function setShortResponseInteractions(obj,params){
    let shortResponses = [];
    _.forEach(params.renderedQuestions, function (data) {
        let response = setShortResponseInteractionData(obj, params, data);
        shortResponses = dataHelper.immutablePush(shortResponses,response);
    });

    return shortResponses;
}

function setShortResponseInteractionData(obj,params,responseData){
    let objLocale = appHelper.getLocalData(obj);
    let responseLocale = appHelper.getLocalData(responseData);
    //console.log(`response`,responseData.response);
    let resultParam = Object.assign({}, xAPIModels.RESULT,{
        completion:  true,
        //success: true, //obj.scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE || params.latestResponse.result === objectConstants.RESULT_BEST,
        response: responseData.response,
        score: obj.assess_type === objectConstants.ASSESSED_TYPE_SCORED && params.kpi_user_rating.value !== null ? setSelfRatingScore(obj, params) : xAPIModels.BEST_SCORE
    });


    //console.log(`setShortResponseInteractionData resultParam`,resultParam);

    let objectParam =  Object.assign({}, xAPIModels.FILL_IN_OBJECT, {

        id: setShortResponseId(obj,responseData),
        definition: {
            name:{
                //"en-US": striptags(objLocale.description)
                "en-US": striptags(responseLocale.prompt)
            },
            description:{
                "en-US": striptags(responseLocale.prompt)
            },
            type: 'http://adlnet.gov/expapi/activities/cmi.interaction',
            interactionType : "fill-in",
            //correctResponsesPattern: [striptags(responseData.response)],

        },

    });

    return Object.assign({},xAPIModels.FILL_IN,{
        result: resultParam,
        object: objectParam
    });

}

export function getShortResponseIds(obj,params){
    let shortResponseIds = [];
    _.forEach(params.renderedQuestions, function (data) {
        let activityId = "";

        if(appHelper.isDefined(params.parent_screen_id)) {
            activityId = `bite_id:${params.bite_id}/screen_id:${params.parent_screen_id}/sub_screen_id:${params.screen_id}/asset_id:${params.asset_id}/id:${data.id}`;
        }else{
            activityId = `bite_id:${params.bite_id}/screen_id:${params.screen_id}/asset_id:${params.asset_id}/id:${data.id}`;
        }

        let response = {
            id: data.id,
            activityId: activityId,
        };
        shortResponseIds = dataHelper.immutablePush(shortResponseIds,response,params);
    });

    return shortResponseIds;
}
//Private functions

function setId(obj,responseObj){
    return `asset_id:${obj.asset_id}`;
}

function setShortResponseId(obj,responseData){
    return `asset_id:${obj.asset_id}/id:${responseData.id}`;
}

function setSelfRatingScore(obj, responseObj){
    let max = 2;
    let min = -2;
    let raw = responseObj.kpi_user_rating.value !== null ? responseObj.kpi_user_rating.value : 0;


    return {
        scaled: dataHelper.getRangePercentage(min,max,raw) / 100,
        min: min,
        max: max,
        raw: raw
    };

}

function setScore(obj, responseObj){
    let score_kpi_id = appHelper.getArrayObjectByKey(localStorage.bites,"bite_id",responseObj.bite_id).score_kpi.kpi_id;
    let score_kpi = appHelper.isDefined(responseObj.outcome) ? appHelper.getArrayObjectByKey(responseObj.outcome.kpis,"kpi_id",score_kpi_id) : appHelper.getArrayObjectByKey(responseObj.latestResponse.kpis,"kpi_id",score_kpi_id);
    let max = 2;
    let min = -2;
    let raw = appHelper.isDefined(score_kpi) ? score_kpi.value : 0;
    let bestScore = kpiHelper.getObjectBestPoints(obj.options, score_kpi_id);

    if(bestScore < -2 || bestScore > 2){
        raw = kpiHelper.scaleKpiValue(raw, obj.options, score_kpi_id);
    }

    return {
        scaled: dataHelper.getRangePercentage(min,max,raw) / 100,
        min: min,
        max: max,
        raw: raw
    };


}


function setQuestionResponses(checkedOptions){
    let responses = [];
    _.forEach(checkedOptions, function (option) {
        let optionLocale = appHelper.getLocalData(option);
        //responses = dataHelper.immutablePush(responses,option.option_id.toString());
        responses = dataHelper.immutablePush(responses,striptags(optionLocale.option));
    });
    return responses.join("[,]");
}


function setChoices(options){
    let choices = [];
    _.forEach(options, function (option) {
        let optionLocale = appHelper.getLocalData(option);
        let choice = {
            id: option.option_id.toString(),
            description: {
                "en-US": striptags(optionLocale.option)
            }
        };
        /*let choice = {
            id: option.option_id.toString(),
            description: {
                "en-US": optionLocale.option
            }
        };*/

        choices = dataHelper.immutablePush(choices,choice);
    });

    return choices;
}

function getScoreObj(scoring_type, result){
    let score = xAPIModels.BEST_SCORE;
    if(scoring_type === objectConstants.SCORING_TYPE_REFLECTIVE){
        return score;
    }else{
        switch (result) {
            case objectConstants.RESULT_BEST:
                score = xAPIModels.BEST_SCORE;
                break;
            case objectConstants.RESULT_OK:
                score = xAPIModels.OK_SCORE;
                break;
            case objectConstants.RESULT_POOR:
                score = xAPIModels.POOR_SCORE;
                break;
            default:
                score = xAPIModels.BEST_SCORE;
        }
        return score;
    }

}

export function getChoiceByDescription(choices,description){
    let returnObject = {};
    _.forEach(choices, function (choice) {

        if(choice.description["en-US"] === description){
             returnObject = Object.assign({},choice);
        }
    });

    return returnObject;
}


export function setUserAsAnonymous(){
    let cookieName = "actor";
    let actor = {};
    let actorCookie = getUserCookie(cookieName);


    if(actorCookie === ""){
        let d = new Date();
        let n = d.getTime();
        let email_address = `${String(n)}@guest.com`;
        let name = `Guest ${String(n)}`;

        actor = {
            objectType: "Agent",
            name: name,
            mbox: `mailto:${email_address}`
        };

        setUserCookie(cookieName, JSON.stringify(actor), 2);

        return actor;
    }else{
        actor = JSON.parse(actorCookie);
        return actor;
    }
}

function setUserCookie(cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


function getUserCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}



/** WEBPACK FOOTER **
 ** ./src/helpers/xAPIHelper.js
 **/